import Cookies from 'js-cookie'
export function GetUrlParam(paraName) {
　　　　var url = document.location.toString();
　　　　var arrObj = url.split("?");
　　　　if (arrObj.length > 1) {
　　　　　　var arrPara = arrObj[1].split("&");
　　　　　　var arr;

　　　　　　for (var i = 0; i < arrPara.length; i++) {
　　　　　　　　arr = arrPara[i].split("=");

　　　　　　　　if (arr != null && arr[0] === paraName) {
　　　　　　　　　　return arr[1];
　　　　　　　　}
　　　　　　}
　　　　　　return "";
　　　　}
　　　　else {
　　　　　　return "";
　　　　}
}
export const orgList = [
    {"id":4,"name":"人力资源服务商","code":"1002015","remark":"服务行业整合资源", link: `${process.env.REACT_APP_SSO_URL}/sso`},
    {"id":3,"name":"用工企业","code":"1002010","remark":"助力企业优化人力结构", link: `${process.env.REACT_APP_SSO_URL}/sso`},
    {"id":2,"name":"运营商","code":"1002020","remark":"助力用工企业成长降低用工成本", link: `${process.env.REACT_APP_SSO_URL}/sso`},
    {"id":1,"name":"平台端","code":"1002005","remark":"平台端", link: `${process.env.REACT_APP_SSO_URL}/site-login?code=1002005`}
]
export function loginOutContor () {
    //const loginInfo = JSON.parse(localStorage.getItem('loginInfo') || '{}')
    Cookies.remove('token')
    localStorage.setItem('loginInfo', null)
    // const orgListItem = orgList.find(item => item.code === loginInfo.orgTypeCode) || {}
    window.location.href = `${process.env.REACT_APP_SSO_URL}/sso`
}